import {Component, HostListener, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {COIService} from 'src/app/shared/services/coi.service';
import {MessagesService} from '../../services/messages.service';
import {COIMessage} from '../../models/coi-message';
import {MenuService} from '../../services/menu.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  userName: string;
  logoImg: string;
  isMobileMenu: boolean;
  showMobileMenu: boolean;

  constructor(public router: Router,
              public coiService: COIService,
              private messagesService: MessagesService,
              private menuService: MenuService) {
    this.getScreenSize();

    this.menuService.isMenuOpen.subscribe(isOpenMenu => {
      this.showMobileMenu = isOpenMenu;
    });
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.isMobileMenu = window.innerWidth < 992;
  }

  ngOnInit() {
    this.userName = this.coiService.getUserName();
    this.logoImg = this.coiService.getHeaderLogo();
  }

  toggleMenu() {
    this.menuService.toggleMenu();
  }

  getBannerLogo() {
    return 'assets/images/' + this.logoImg;
  }
}
